// Mock data for Vector FX

export const NAV_LINKS = [
  { id: 'property', label: 'Property', href: '#property' },
  { id: 'business', label: 'Business', href: '#business' },
  { id: 'personal', label: 'Personal', href: '#personal' },
  { id: 'about', label: 'About', href: '#about' },
];

export const HERO = {
  title: 'Move money',
  titleAccent: 'with direction.',
  subtitle:
    'A global platform for cross border payments, alternative banking and property settlements engineered for people and businesses that refuse to wait.',
  primaryCta: 'Open an account',
  secondaryCta: 'Talk to a specialist',
  metrics: [
    { value: '£1B+', label: 'Transferred every year' },
    { value: '135', label: 'Countries covered' },
    { value: '48', label: 'Currencies supported' },
    { value: '4.9★', label: 'Rated on Trustpilot' },
  ],
};

// Cities plotted on the hero world map (lat, lon). London is the origin.
export const MAP_ORIGIN = { name: 'London', code: 'GBP', lat: 51.5, lon: -0.1 };
export const MAP_CITIES = [
  { name: 'New York',    code: 'USD', lat: 40.7,  lon: -74.0 },
  { name: 'Toronto',     code: 'CAD', lat: 43.7,  lon: -79.4 },
  { name: 'Madrid',      code: 'EUR', lat: 40.4,  lon: -3.7  },
  { name: 'Frankfurt',   code: 'EUR', lat: 50.1,  lon: 8.7   },
  { name: 'Dubai',       code: 'AED', lat: 25.2,  lon: 55.3  },
  { name: 'Mumbai',      code: 'INR', lat: 19.1,  lon: 72.9  },
  { name: 'Singapore',   code: 'SGD', lat: 1.3,   lon: 103.8 },
  { name: 'Hong Kong',   code: 'HKD', lat: 22.3,  lon: 114.2 },
  { name: 'Tokyo',       code: 'JPY', lat: 35.7,  lon: 139.7 },
  { name: 'Sydney',      code: 'AUD', lat: -33.9, lon: 151.2 },
  { name: 'Cape Town',   code: 'ZAR', lat: -33.9, lon: 18.4  },
  { name: 'São Paulo',    code: 'BRL', lat: -23.5, lon: -46.6 },
];

export const PROPERTY = {
  eyebrow: 'Property settlements',
  title: 'The cleanest way to close a cross-border deal.',
  body:
    'From a Notting Hill flat to a villa on the Costa del Sol, Vector FX handles the currency, the compliance and the client experience so conveyancers, agents and buyers all sit on the same side of the table.',
  products: [
    {
      tag: 'Settle',
      title: 'Vector Settle',
      description:
        'A single ledger for buyers, sellers, solicitors and agents. Track every payment, every signature, every hold in real time.',
      link: 'Explore Settle',
    },
    {
      tag: 'Referrals',
      title: 'Vector Bridge',
      description:
        'Bolt on an international-buyer FX referral programme in one afternoon. Earn recurring revenue and turn your clients into repeat clients.',
      link: 'Explore Bridge',
    },
  ],
};

export const PARTNERS = [
  'Harringtons Legal',
  'Coastline Homes',
  'Meridian Estates',
  'Blackwood & Kerr',
  'Ibiza Properties',
  'North Star Realty',
];

export const BUSINESS = {
  eyebrow: 'Global business payments',
  title: 'One platform. Every currency your business touches.',
  body:
    'From payroll to procurement, Vector FX gives finance teams the tools to move money quickly, safely and at rates that actually make sense.',
  cards: [
    {
      title: 'Bulk Pay',
      description:
        'Upload a CSV, approve once, pay hundreds of suppliers or contractors in 40+ currencies. Reconciliation is automatic.',
      link: 'Discover Bulk Pay',
    },
    {
      title: 'Vector Forward',
      description:
        'Forward contracts and hedging solutions for private, corporate and institutional clients. Lock in a rate today, settle up to 24 months later.',
      link: 'Explore Forward',
    },
    {
      title: 'Global Payroll',
      description:
        'Pay teams across borders on payday with live FX visibility, compliance built in, and zero manual spreadsheets.',
      link: 'See Payroll',
    },
  ],
};

export const PERSONAL = {
  eyebrow: 'Personal transfers',
  title: 'Send money like you live abroad.',
  body:
    'Bank-beating rates, zero transfer fees, and human specialists you can actually call. Whether you are buying a home overseas or paying school fees, the money arrives when it needs to.',
  cards: [
    {
      title: 'International transfers',
      description:
        'Lock in a rate today, send when you are ready. Track every step from your phone.',
    },
    {
      title: 'Multi-currency account',
      description:
        'One account. 40+ currencies. Hold, receive and spend at the real rate in 200+ countries.',
    },
    {
      title: 'Vector Wallet',
      description:
        'Hold, convert and send between currencies inside a single account you actually own.',
    },
  ],
};

export const COUNTRIES = [
  { name: 'United Kingdom', code: 'gb' },
  { name: 'United States', code: 'us' },
  { name: 'Spain', code: 'es' },
  { name: 'France', code: 'fr' },
  { name: 'Italy', code: 'it' },
  { name: 'Portugal', code: 'pt' },
  { name: 'Germany', code: 'de' },
  { name: 'Ireland', code: 'ie' },
  { name: 'Canada', code: 'ca' },
  { name: 'Australia', code: 'au' },
  { name: 'UAE', code: 'ae' },
  { name: 'South Africa', code: 'za' },
];

export const CURRENCIES = [
  { name: 'Pound sterling', code: 'GBP' },
  { name: 'Euro', code: 'EUR' },
  { name: 'US dollar', code: 'USD' },
  { name: 'Canadian dollar', code: 'CAD' },
  { name: 'Australian dollar', code: 'AUD' },
  { name: 'New Zealand dollar', code: 'NZD' },
  { name: 'Japanese yen', code: 'JPY' },
  { name: 'South African rand', code: 'ZAR' },
  { name: 'UAE dirham', code: 'AED' },
  { name: 'Norwegian krone', code: 'NOK' },
  { name: 'Swedish krona', code: 'SEK' },
  { name: 'Danish krone', code: 'DKK' },
];

export const TESTIMONIALS = [
  {
    quote:
      'We settled a €4.2M cross-border property deal in eleven days. With our old provider it took eight weeks.',
    name: 'Ana Herrero',
    role: 'Partner, Herrero & Vega Abogados',
  },
  {
    quote:
      'Vector Forward let us lock in a 12-month EUR rate on a £8M supplier contract. Our margin stopped moving overnight.',
    name: 'Priya Ramaswamy',
    role: 'Head of Finance, Loopyard',
  },
  {
    quote:
      'I speak to the same specialist every time I move money to Portugal. That kind of service is basically extinct.',
    name: 'Miriam Clarke',
    role: 'Retired teacher, Lisbon',
  },
];

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1506501139174-099022df5260?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxsb25kb24lMjBza3lsaW5lfGVufDB8fHx8MTc4NjE4MTQ2MXww&ixlib=rb-4.1.0&q=85',
  property: 'https://images.unsplash.com/photo-1629199159634-28a88785cee5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtZWRpdGVycmFuZWFuJTIwdmlsbGF8ZW58MHx8fHwxNzg2MTgxNDYyfDA&ixlib=rb-4.1.0&q=85',
  business: 'https://images.pexels.com/photos/3747070/pexels-photo-3747070.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  personal: 'https://images.unsplash.com/photo-1530789253388-582c481c54b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxjb3VwbGUlMjB0cmF2ZWxpbmd8ZW58MHx8fHwxNzg2MTgxNDYxfDA&ixlib=rb-4.1.0&q=85',
  careers: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHx0ZWFtJTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3ODYxODE0NjJ8MA&ixlib=rb-4.1.0&q=85',
};
